var CurrentUser = require('lib/account/CurrentUser');

var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var LoadingButton = require("components/utility/LoadingButton");
var ErrorBoundary = require("components/utility/ErrorBoundary")

var WarmupQuestions = require("lib/academic/WarmupQuestions");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

var FictionCharactersQuestion = require("components/writing/quizzes/warmups/FictionCharactersQuestion");
var FictionMainIdeasQuestion = require("components/writing/quizzes/warmups/FictionMainIdeasQuestion");
var FictionPlotQuestion = require("components/writing/quizzes/warmups/FictionPlotQuestion");
var FictionSettingQuestion = require("components/writing/quizzes/warmups/FictionSettingQuestion");
var FictionOrganizationQuestion = require("components/writing/quizzes/warmups/FictionOrganizationQuestion");
var FictionPointOfViewQuestion = require("components/writing/quizzes/warmups/FictionPointOfViewQuestion");
var FictionPicturesQuestion = require("components/writing/quizzes/warmups/FictionPicturesQuestion");
var FictionComparisonQuestion = require("components/writing/quizzes/warmups/FictionComparisonQuestion");
var FictionEmotionQuestion = require("components/writing/quizzes/warmups/FictionEmotionQuestion");
var FictionVocabularyQuestion = require("components/writing/quizzes/warmups/FictionVocabularyQuestion");

var NonFictionSubjectQuestion = require("components/writing/quizzes/warmups/NonFictionSubjectQuestion");
var NonFictionMainIdeasQuestion = require("components/writing/quizzes/warmups/NonFictionMainIdeasQuestion");
var NonFictionOrganizationQuestion = require("components/writing/quizzes/warmups/NonFictionOrganizationQuestion");
var NonFictionPointOfViewQuestion = require("components/writing/quizzes/warmups/NonFictionPointOfViewQuestion");
var NonFictionPicturesQuestion = require("components/writing/quizzes/warmups/NonFictionPicturesQuestion");
var NonFictionComparisonQuestion = require("components/writing/quizzes/warmups/NonFictionComparisonQuestion");
var NonFictionVocabularyQuestion = require("components/writing/quizzes/warmups/NonFictionVocabularyQuestion");
var NonFictionArgumentsQuestion = require("components/writing/quizzes/warmups/NonFictionArgumentsQuestion");

var Skillsets = require("lib/academic/Skillsets");
var Glyphicon = require("components/utility/icons/Glyphicon");


var ComponentDemonstrator = require('components/users/students/onboarding/ComponentDemonstrator');

import ReactSelect from "react-select";

require("writing/quizzes/warmups/warmup_questions_display.scss");

class WarmupQuestionsDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		// assume only one key value pair in initAnswers when displayOnly
		if (props.displayOnly) {
			var questionKey = props.displayOnlyKey;
			var answers = props.initAnswers;
		} else {
			// assume that we save warmup answers between every recall question, not intra-question
			var initialAnswers = props.initAnswers;
			// if (initialAnswers && initialAnswers[TopicQuestion.STEM]) {
			// 	var questionKey = this.getRecallQuestionStem(initialAnswers);
			// 	var answers = initialAnswers;
			// } else {
			var questionKey = TopicQuestion.STEM;
			var answers = {};
			// }
		}

		answers = _.extend({}, answers, { level: props.level });

		this.state = {
			currentQuestion: questionKey, answers: answers, loading: false
		}
	}

	//////////////////// functions called by question components ////////////////////
	getTextForPart(part, stage, replacementsHash = {}) {
		var key = this.getKeyForPart(part, stage);

		// set up to replace text_type, since most components use it
		var topicAnswers = this.state.answers[TopicQuestion.STEM];
		if (topicAnswers && topicAnswers[TopicQuestion.TEXT_TYPE]) {
			replacementsHash[WarmupQuestions.TEXT_TYPE] = topicAnswers[TopicQuestion.TEXT_TYPE];
		}

		// set up to replace entity_type for nonfiction
		if (topicAnswers && topicAnswers[TopicQuestion.MAIN_ENTITY]) {
			replacementsHash[WarmupQuestions.ENTITY_TYPE] = topicAnswers[TopicQuestion.MAIN_ENTITY];
		}

		var text = WarmupQuestions.getText(key, replacementsHash);

		return text;
	}
	pickAndSaveOption(answerKey, options) {
		var randomIndex = Math.floor((Math.random() * options.length));
		this.updateAnswers(answerKey, options[randomIndex]);
	}
	renderInput(answerKey, whitelistKeys, inputType = "text") {
		if (this.props.displayOnly) {
			return (
				<div className="displayOnly">
					{ " " }{ this.props.initAnswers[this.state.currentQuestion][answerKey] }{ " " }
				</div>
			);
		}

		var currentAnswers = this.state.answers[this.state.currentQuestion];
		if (currentAnswers) {
			var defaultText = currentAnswers[answerKey] || "";
		} else {
			var defaultText = "";
		}

		var inputClassName = "inlineInput";
		if (inputType == "number") {
			inputClassName += " numberInput";
		}

		return (
			<input type={ inputType } className={ inputClassName } value={ defaultText }
				onChange={ this.onInputChange.bind(this, answerKey, whitelistKeys) } />
		);
	}
	renderDropdown(part, stage, answerKey, whitelistKeys, replacementsHash = {}) {
		if (this.props.displayOnly) {
			return (
				<div className="displayOnly">
					{ " " }{ this.props.initAnswers[this.state.currentQuestion][answerKey] }{ " " }
				</div>
			);
		}

		var optionKey = this.getKeyForPart(part, stage);
		var options = WarmupQuestions.getText(optionKey, replacementsHash).split(",").map((option) => {
			var op = option.trim();
			return (
				<ButtonDropdownOption text={ op } key={ op }
					onClick={ this.updateAnswers.bind(this, answerKey, op, whitelistKeys) } />
			);
		});

		var answers = this.state.answers[this.state.currentQuestion];
		if (answers && answers[answerKey]) {
			var displayText = answers[answerKey];
		} else {
			var displayText = "pick one";
		}

		return (
			<ButtonDropdown text={ displayText }>
				{ options }
			</ButtonDropdown>
		);
	}
	renderMultiSelect(part, stage, answerKey, maxSelect = -1, whitelistKeys) {
		if (this.props.displayOnly) {
			return (
				<div className="displayOnly">
					{ " " }{ this.props.initAnswers[this.state.currentQuestion][answerKey].split(",").join(", ") }{ " " }
				</div>
			);
		}

		var optionKey = this.getKeyForPart(part, stage);
		var options = WarmupQuestions.getText(optionKey).split(",").map((option) => {
			var op = option.trim();
			return { value: op, label: op };
		});

		var answers = this.state.answers[this.state.currentQuestion];
		if (answers && answers[answerKey]) {
			var displayText = answers[answerKey];
		}

		// to adjust the width of the select bar
		var selectClassName = "multiSelect";
		if (maxSelect == 1) {
			selectClassName += " oneOption";
		} else if (maxSelect == 2) {
			selectClassName += " twoOptions";
		} else if (maxSelect == 3) {
			selectClassName += " threeOptions";
		} else {
			selectClassName += " noMaxOptions";
		}

		return (
			<ReactSelect name={ answerKey } options={ options } value={ displayText }
				multi={ true } joinValues={ true } delimiter="," simpleValue={ true }
				className={ selectClassName } autoBlur={ true }
				onChange={ this.onMultiSelectChange.bind(this, answerKey, maxSelect, whitelistKeys) } />
		);
	}
	renderFinishButton() {
		if (this.props.displayOnly) { return; }

		if (this.state.currentQuestion == TopicQuestion.STEM) {
			var onClickF = this.nextRecallQuestion;
		} else {
			var onClickF = this.submitWarmupAnswers;
		}

		return (
			<LoadingButton className="btn buttonPrimary finishButton" text="Next Question"
				onClick={ () => this.setState({ loading: true }, onClickF) }
				loading={ this.state.loading } />
		);
	}
	////////////////////////////////////////////////////////////////////////////////


	//////////////////// internal functions ////////////////////////////////////////
	getKeyForPart(part, stage) {
		var stem = this.state.currentQuestion;
		var level = this.props.level;
		return WarmupQuestions.getKey(stem, stage, part, level);
	}
	onInputChange(key, whitelistKeys, event) {
		var newValue = event.target.value;
		this.updateAnswers(key, newValue, whitelistKeys);
	}
	updateAnswers(key, value, whitelistKeys) {
		var currentQuestion = this.state.currentQuestion;
		var updatedAnswers = _.clone(this.state.answers);
		if (updatedAnswers[currentQuestion] == undefined) {
			updatedAnswers[currentQuestion] = {};
		}

		if (whitelistKeys != undefined) {
			updatedAnswers[currentQuestion] = _.pick(updatedAnswers[currentQuestion], whitelistKeys);
		} else {
			updatedAnswers[currentQuestion] = _.clone(updatedAnswers[currentQuestion]);
		}
		// update the key's value if there is content
		if (value && value.trim().length > 0) {
			updatedAnswers[currentQuestion][key] = value;
			this.setState({ answers: updatedAnswers });

		// otherwise, remove the key from the answers object
		} else {
			updatedAnswers[currentQuestion] = _.omit(updatedAnswers[currentQuestion], key);
			this.setState({ answers: updatedAnswers });
		}

	}
	onMultiSelectChange(answerKey, maxSelect, whitelistKeys, selectedOptions) {
		// return if we have reached the maximum number of options
		if (maxSelect > 0 && selectedOptions.split(",").length > maxSelect) {
			// should never be greater, but just in case
			var notificationText = "You can only pick " + maxSelect + ".";
			window.wrNotifications.triggerDropDownNotification({
				title: "Question Tip", text: notificationText, 
				icon: "exclamation-sign", type: "error" });
			return;
		}

		this.updateAnswers(answerKey, selectedOptions, whitelistKeys);
	}
	getRecallQuestionStem(answers) {
		var overlapStems = this.getStemOptions();
		return _.sample(overlapStems);
	}

	nextRecallQuestion() {
		var questionKey = this.getRecallQuestionStem(this.state.answers);
		this.props.onFinishQuestionF(this.state.answers, false,
			() => this.setState({ currentQuestion: questionKey, loading: false }));
	}
	submitWarmupAnswers() {
		this.props.onFinishQuestionF(this.state.answers, true);
	}
	changeQuestion() {
		var initialAnswers = this.props.initAnswers;
		var questionKey = this.getRecallQuestionStem(initialAnswers);
		var answers = initialAnswers;
			
		this.setState({ currentQuestion: questionKey, answers: answers })
	}

	isNonFiction() {
		if ((!this.state) || (!this.state.answers)) { return false; }
		var topicAnswer = this.state.answers[TopicQuestion.STEM];
		if (topicAnswer && topicAnswer[TopicQuestion.TEXT_VARIETY]) {
			return topicAnswer[TopicQuestion.TEXT_VARIETY].includes("non-fiction");
		}
	}

	getStemOptions() {
		if (this.isNonFiction()) {
			var baseStems = WarmupQuestionsDisplay.NON_FICTION_RECALL_OPTIONS;
		} else {
			var baseStems = WarmupQuestionsDisplay.FICTION_RECALL_OPTIONS;
		}

		return baseStems;
	}

	////////////////////////////////////////////////////////////////////////////////

	render() {
		var currentQuestion = this.state.currentQuestion;
		var demoComponent = "warmup_question_2"

		if (currentQuestion == TopicQuestion.STEM) {
			demoComponent = "warmup_question_1"
			var questionDisplay = <TopicQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } renderMultiSelectF={ this.renderMultiSelect }
				renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionCharactersQuestion.STEM) {
			var questionDisplay = <FictionCharactersQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } renderMultiSelectF={ this.renderMultiSelect }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionMainIdeasQuestion.STEM) {
			var questionDisplay = <FictionMainIdeasQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionPlotQuestion.STEM) {
			var questionDisplay = <FictionPlotQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionSettingQuestion.STEM) {
			var questionDisplay = <FictionSettingQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderMultiSelectF={ this.renderMultiSelect }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionOrganizationQuestion.STEM) {
			var questionDisplay = <FictionOrganizationQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } pickRandomOptionF={ this.pickAndSaveOption }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionPointOfViewQuestion.STEM) {
			var questionDisplay = <FictionPointOfViewQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } renderMultiSelectF={ this.renderMultiSelect }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionPicturesQuestion.STEM) {
			var questionDisplay = <FictionPicturesQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } renderMultiSelectF={ this.renderMultiSelect }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionComparisonQuestion.STEM) {
			var questionDisplay = <FictionComparisonQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionEmotionQuestion.STEM) {
			var questionDisplay = <FictionEmotionQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderMultiSelectF={ this.renderMultiSelect }
				renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == FictionVocabularyQuestion.STEM) {
			var questionDisplay = <FictionVocabularyQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionSubjectQuestion.STEM) {
			var questionDisplay = <NonFictionSubjectQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionMainIdeasQuestion.STEM) {
			var questionDisplay = <NonFictionMainIdeasQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionOrganizationQuestion.STEM) {
			var questionDisplay = <NonFictionOrganizationQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } pickRandomOptionF={ this.pickAndSaveOption }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionPointOfViewQuestion.STEM) {
			var questionDisplay = <NonFictionPointOfViewQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionPicturesQuestion.STEM) {
			var questionDisplay = <NonFictionPicturesQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown } renderMultiSelectF={ this.renderMultiSelect }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionComparisonQuestion.STEM) {
			var questionDisplay = <NonFictionComparisonQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionVocabularyQuestion.STEM) {
			var questionDisplay = <NonFictionVocabularyQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		} else if (currentQuestion == NonFictionArgumentsQuestion.STEM) {
			var questionDisplay = <NonFictionArgumentsQuestion level={ this.props.level }
				answers={ this.state.answers } getTextF={ this.getTextForPart }
				renderDropdownF={ this.renderDropdown }
				renderInputF={ this.renderInput } renderFinishButtonF={ this.renderFinishButton } />;

		}

		if (!this.props.displayOnly) {
			var stemOptions = this.getStemOptions();

			if (currentQuestion != TopicQuestion.STEM && (stemOptions.length > 1)) {
				var changeQuestionLink = (
					<a className="changeQuestionLink btn" onClick={ this.changeQuestion }>
						Change <Glyphicon icon="refresh" />
					</a>
				)
			}			
		}

		var errorMessage = "Something went wrong with this warmup question. " +
			"Please try again and, if the issue continues, report your username " +
			"and this book title to support@whooosreading.org."

		var content = (
			<ErrorBoundary errorMessage={ errorMessage }>
				{ changeQuestionLink }
				{ questionDisplay }
			</ErrorBoundary>
		)
		if (this.props.demonstrate) {
			content = (
				<ComponentDemonstrator component={demoComponent}>
					{ content }
				</ComponentDemonstrator>
			)
		}
		return (
			<div className="warmupQuestionsDisplay" >
				{ content }
			</div>
		);

	}
}

WarmupQuestionsDisplay.FICTION_RECALL_OPTIONS = [
	FictionCharactersQuestion.STEM, FictionMainIdeasQuestion.STEM, FictionPlotQuestion.STEM,
	FictionSettingQuestion.STEM, FictionOrganizationQuestion.STEM, FictionPointOfViewQuestion.STEM,
	FictionPicturesQuestion.STEM, FictionComparisonQuestion.STEM, FictionEmotionQuestion.STEM,
	FictionVocabularyQuestion.STEM
];
WarmupQuestionsDisplay.NON_FICTION_RECALL_OPTIONS = [
	NonFictionSubjectQuestion.STEM, NonFictionMainIdeasQuestion.STEM,
	NonFictionOrganizationQuestion.STEM, NonFictionPointOfViewQuestion.STEM,
	NonFictionPicturesQuestion.STEM, NonFictionComparisonQuestion.STEM,
	NonFictionVocabularyQuestion.STEM, NonFictionArgumentsQuestion.STEM
];

WarmupQuestionsDisplay.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	onFinishQuestionF: PropTypes.func,
	initAnswers: PropTypes.object,
	displayOnly: PropTypes.bool,
	displayOnlyKey: PropTypes.string,
	demonstrate: PropTypes.bool
});

module.exports = WarmupQuestionsDisplay;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/WarmupQuestionsDisplay.js